import React, { Component } from 'react';
import { connect } from 'react-redux';

// utils
import { Translations } from '../../../utils';
//rest Clients
import { FooterdataBA, FooterdataEN, FooterdataES } from './json_footer-page';
//style
import './Footer.css';

const buildName = process.env.REACT_APP_BUILD;
class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pageJson: {},
      numPages: null,
      showPdf: false,
      objectUrl: null,
      showDeleteModal: false,
      TermAndConditions: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsPortalSiteTnC_EN.pdf') : require('../../../assets/images/cust_PDF/GDocsPortalSiteTnC_EN.pdf'),
      PrivacyNotice: require('../../../assets/images/GDocsDraftPrivacyNotice_EN.pdf'),
      CookeNotice: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsCookieNotice_EN.pdf') : require('../../../assets/images/cust_PDF/GDocsCookieNotice_EN.pdf')
    }
  }

  componentDidMount() {
    if (window.location.pathname === '/staff-login') {
      // aemHostClient("/aemData/formData/json_footer-page")
      // .then(({data}) => {
      //   this.setState({
      //     pageJson: data
      //   });
      // });
    } else {
      this.setState({
        pageJson: FooterdataEN
      }, () => { });
    }
  }

  componentWillReceiveProps(nextProps) {
    switch (nextProps.lang.currentLang.lang) {
      case 'English':
        this.setState({
          pageJson: this.props.footerData !== undefined ? Object.keys(this.props.footerData).length > 0 ? this.props.footerData : FooterdataEN : FooterdataEN,
          TermAndConditions: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsPortalSiteTnC_EN.pdf') : require('../../../assets/images/cust_PDF/GDocsPortalSiteTnC_EN.pdf'),
          PrivacyNotice: require('../../../assets/images/GDocsDraftPrivacyNotice_EN.pdf'),
          CookeNotice: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsCookieNotice_EN.pdf') : require('../../../assets/images/cust_PDF/GDocsCookieNotice_EN.pdf')
        });
        break;
      case 'Spanish':
        this.setState({
          pageJson: this.props.footerData !== undefined ? Object.keys(this.props.footerData).length > 0 ? this.props.footerData : FooterdataES : FooterdataES,
          TermAndConditions: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsPortalSiteTnC_ES.pdf') : require('../../../assets/images/cust_PDF/GDocsPortalSiteTnC_ES.pdf'),
          PrivacyNotice: require('../../../assets/images/GDocsDraftPrivacyNotice_ES.pdf'),
          CookeNotice: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsCookieNotice_ES.pdf') : require('../../../assets/images/cust_PDF/GDocsCookieNotice_ES.pdf')
        });
        break;
      case 'Bahasa':
        this.setState({
          pageJson: this.props.footerData !== undefined ? Object.keys(this.props.footerData).length > 0 ? this.props.footerData : FooterdataBA : FooterdataBA,
          TermAndConditions: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsPortalSiteTnC_ID.pdf') : require('../../../assets/images/cust_PDF/GDocsPortalSiteTnC_ID.pdf'),
          PrivacyNotice: require('../../../assets/images/GDocsDraftPrivacyNotice_ID.pdf'),
          CookeNotice: buildName === 'staff' ? require('../../../assets/images/staff_PDF/GDocsCookieNotice_ID.pdf') : require('../../../assets/images/cust_PDF/GDocsCookieNotice_ID.pdf')
        });
        break;
      default:
        this.setState({
          pageJson: this.props.footerData !== undefined ? Object.keys(this.props.footerData).length > 0 ? this.props.footerData : FooterdataEN : FooterdataEN
        });
    }
  }


  render() {
    const { pageNumber, numPages, TermAndConditions, PrivacyNotice, CookeNotice } = this.state;
    return ((this.state.pageJson.par !== undefined ?
      <footer className="page-footer" name="footer" role="contentinfo">
        <section className="page-footer__section">
          <div className="page-container" role="contentinfo">
            <ul className="page-footer__menu">
              <li className="page-footer__menu-item">
                <a
                  href={TermAndConditions}
                  rel="noopener noreferrer"
                  tabIndex="0"
                  target="_blank"
                  title={this.state.pageJson.par.static_text_darkTitleBar.termsCondition.termss}
                >
                  {Translations(this.state.pageJson.par.static_text_darkTitleBar.termsCondition, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  <i className="icon icon-new-window icon-pad"></i>
                  <span className="visuallyhidden">{this.state.pageJson.par.static_text_darkTitleBar.label}</span>
                </a>
              </li>
              <li className="page-footer__menu-item">
                <a
                  href={PrivacyNotice}
                  target='_blank'
                  tabIndex="0"
                  title={Translations(this.state.pageJson.par.static_text_darkTitleBar.privacy, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                >
                  {Translations(this.state.pageJson.par.static_text_darkTitleBar.privacy, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  <i className="icon icon-new-window icon-pad"></i>
                  <span className="visuallyhidden">{this.state.pageJson.par.static_text_darkTitleBar.label}</span>
                </a>
              </li>
              <li className="page-footer__menu-item">
                <a
                  href={CookeNotice}
                  rel="noopener noreferrer"
                  tabIndex="0"
                  target="_blank"
                  title={Translations(this.state.pageJson.par.static_text_darkTitleBar.cookies, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                >
                  {Translations(this.state.pageJson.par.static_text_darkTitleBar.cookies, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  <i className="icon icon-new-window icon-pad"></i>
                  <span className="visuallyhidden">{this.state.pageJson.par.static_text_darkTitleBar.label}</span>
                </a>
              </li>
            </ul>
            <div className="page-footer__menu-item page-footer__menu-item--copyright">
              <span
                title={this.props.copyright}
              >
                &copy; {this.props.copyright}
              </span>
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </section>
        <section className="page-footer__section">
          <div className="page-container" role="contentinfo">
            {
              (this.props.TPDisclaimer) &&
              <p
                className="page-footer__disclaimer"
                title={this.props.TPDisclaimer}
              >
                {this.props.TPDisclaimer}
              </p>
            }
          </div>
        </section>
      </footer>
      : '')
    )
  }
}
const mapStateToProps = state => {
  return {
    lang: state.lang,
    footerDetails: state.footerData
  }
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/layouts/Footer/Footer.js